import React from 'react'
import { ContainerField, Label } from '@sencha/ext-modern'
import { getMixedProps } from './blockPublic'
import { genHtml } from './base/MultiLines/rteFuns'

const Html = ({ field, /* onChange, initValues, changedValues,  */defaultStyle }) => {
	const { props: { label, style = {}, value: valueProp, contentNoLocale, doTrans, ...props } }
		= getMixedProps('_html', [defaultStyle, field])
	// console.log('contentnolocale:', contentNoLocale)
	const value = doTrans ? doTrans(valueProp) : genHtml(valueProp)
	return <ContainerField layout='vbox' label={label} {...props}  >
		<Label userCls='t-formrichtext' errorTarget={undefined} html={value || ''} noLocale={contentNoLocale} style={style} />
	</ContainerField>
	// 	<Label html={value} /> 
	// 或
	// <div dangerouslySetInnerHTML={{ __html: value }} />
}

const renderHtml = config => {
	const { key } = config.field || {}
	return <Html key={key} {...config} />
}

export default renderHtml